import { render, staticRenderFns } from "./HelpToGetStarted.vue?vue&type=template&id=4676fa0c&lang=pug"
import script from "./HelpToGetStarted.vue?vue&type=script&lang=js"
export * from "./HelpToGetStarted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports